import { Link } from 'react-router-dom';
import { SUB_AFFILIATES_ROUTE } from 'src/constants';

export const Users = () => (
    <div>
        <Link to={SUB_AFFILIATES_ROUTE.url}>{SUB_AFFILIATES_ROUTE.title}</Link>
    </div>
);
